import React, { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { CheckCircle2, MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import { attribution, track } from "@/lib/analytics";

const NOTE = "Vuole parlare con un consulente prima di confermare l'ordine. Mantenere il prezzo online (€5.490 + IVA + trasporto, consegna in 3 mesi).";

export const CallbackMini = ({ source = "offer", dark = false }) => {
  const [form, setForm] = useState({ first_name: "", phone: "", privacy_consent: false });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const tid = (s) => `callback-${source}-${s}`;

  const submit = async (e) => {
    e.preventDefault();
    if (!form.first_name || !form.phone) return toast.error("Inserisci nome e telefono.");
    if (!form.privacy_consent) return toast.error("È necessario accettare la privacy policy.");
    setLoading(true);
    try {
      await api.post("/leads", { ...form, notes: NOTE, lead_type: "quick", requested_action: "callback", ...attribution() });
      track("lead_form_submit", { form: "callback_mini", source });
      setSent(true);
    } catch { toast.error("Errore nell'invio. Riprova."); }
    finally { setLoading(false); }
  };

  const box = dark ? "bg-white text-slate-900" : "bg-slate-50 border border-slate-200 text-slate-900";
  if (sent) return (
    <div className={`rounded-2xl p-5 text-center ${box}`} data-testid={tid("success")}>
      <CheckCircle2 className="mx-auto text-emerald-700 mb-2" size={36} />
      <p className="font-bold">Grazie {form.first_name}, ti richiamiamo a breve.</p>
      <p className="text-sm text-slate-600 mt-1">Il prezzo online resta bloccato per te.</p>
    </div>
  );

  return (
    <form onSubmit={submit} className={`rounded-2xl p-5 text-left ${box}`} data-testid={tid("form")}>
      <p className="flex items-center gap-2 font-extrabold text-lg" style={{ fontFamily: "Outfit" }}>
        <MessageCircle size={20} className="text-[var(--sc-emerald)]" /> Hai dubbi? Ti richiamiamo noi
      </p>
      <p className="text-sm text-slate-600 mt-1">Lascia nome e telefono: un collega risponde alle tue domande e il <strong>prezzo online resta bloccato</strong>.</p>
      <div className="mt-3 grid sm:grid-cols-2 gap-2">
        <Input placeholder="Nome *" value={form.first_name} onChange={(e) => setForm({ ...form, first_name: e.target.value })} className="h-12" data-testid={tid("name")} />
        <Input placeholder="Telefono *" type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="h-12" data-testid={tid("phone")} />
      </div>
      <label className="mt-3 flex items-start gap-2 text-xs text-slate-600">
        <Checkbox checked={form.privacy_consent} onCheckedChange={(v) => setForm({ ...form, privacy_consent: !!v })} className="mt-0.5" data-testid={tid("privacy")} />
        <span>Accetto la <a href="/privacy" className="underline">Privacy Policy</a>. *</span>
      </label>
      <Button type="submit" disabled={loading} className="mt-3 w-full h-12 font-bold text-white rounded-full" style={{ backgroundColor: "var(--sc-emerald)" }} data-testid={tid("submit")}>
        {loading ? "Invio in corso..." : "Richiamami"}
      </Button>
    </form>
  );
};
